import { editButton } from "assets/icons";
import { profilePlaceholder } from "assets/images";
import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "redux-toolkit/slices/userProfileSlice";
import { editProfileApi } from "services/profile";
import { failMessage, successMessage } from "utils/toastMessage";

const EditProfile = ({ profile }) => {
  const dispatch = useDispatch();
  const { selectedSite } = useSelector((state) => (state?.selectedSite))
  const [uploading, setUploading] = useState(false);
  // console.log('profile', profile)

  ///------------onchange-handler---------------
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (!allowedTypes.includes(file.type)) {
        failMessage("Only PNG, JPG, and JPEG files are allowed!");
        e.target.value = "";
        return;
      }
      try {
        setUploading(true);
        const formData = new FormData();
        formData.append("image", file);
        const response = await editProfileApi(formData);
        if (response.status === 200) {
          if (selectedSite?._id) {
            dispatch(fetchUserProfile(selectedSite?._id));
          }
          // successMessage(response);
        } else {
          failMessage(response);
        }
      } catch (error) {
        console.error("Upload Error:", error);
      } finally {
        setUploading(false);
      }
    }
  };
  return (
    <div className="profile_image">
      <img
        src={profile || profilePlaceholder}
        alt="profile"
        className="profile"
      />

      {uploading && (
        <Spinner className="spinier-loader" animation="border" variant="light" />
        
      )}

      <label htmlFor="profile_image">
        <input
          type="file"
          id="profile_image"
          accept="image/png, image/jpeg, image/jpg"
          disabled={uploading}
          onChange={handleImageChange}
        />
        <img src={editButton} alt="edit" />
      </label>
    </div>

  );
};

export default EditProfile;
